var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnsmiley(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(-934 -209)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(934 209)",
    fill: "#ff91ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(946.646 222.431)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 4,
    cy: 4.5,
    rx: 4,
    ry: 4.5,
    transform: "translate(0.354 -0.431)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 4,
    cy: 4.5,
    rx: 4,
    ry: 4.5,
    transform: "translate(18.354 -0.431)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M6580,176.867s13.607,13.892,27.149,0",
    transform: "translate(7553.563 426.011) rotate(180)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsmiley);
export default __webpack_public_path__ + "static/media/unsmiley.6f428bb8aaa6ab7e97eb2a2e055ea845.svg";
export { ForwardRef as ReactComponent };